<div class="content">
  <div class="heading">{{ 'app.pricing.plan_picker_2024.footer.heading' | translate }}</div>
  <div class="row gap">
    <div class="column">
      @for (feature of model.left; track trackByIndex($index, feature)) {
        <rt-feature-item [label]="feature.label" [tooltip]="feature.tooltip" />
      }
    </div>
    <div class="column center-y">
      @for (feature of model.right; track trackByIndex($index, feature)) {
        <rt-feature-item [label]="feature.label" [tooltip]="feature.tooltip" />
      }
    </div>
  </div>
</div>
